import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import {useAuthorizedViaAdmin} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";
import {PageShell, type TabRoute} from "../layout/PageShell";
import AutocompleteTestPage from "./autocomplete/AutocompleteTestPage";
import BlackoutTestPage from "./blackout/BlackoutTestPage";
import ChipIconsTestPage from "./chip-icons/ChipIconsTestPage";
import NewDatePickerTestPage from "./date-pickers/NewDatePickerTestPage";
import EmojiPickerTestPage from "./emoji-picker/EmojiPickerTestPage";
import MuiComponentsTestPage from "./mui-components/MuiComponentsTestPage";
import NewVariablePickerTestPage from "./new-variable-picker/NewVariablePickerTestPage";
import RichTextTestPage from "./rich-text/RichTextTestPage";
import SelectsTestPage from "./selects/SelectsTestPage";
import {UiElementTestPage} from "./ui-elements/UiElementTestPage";
import {Navigate, useLocation} from "react-router-dom";

const tabs: TabRoute[] = [
    {
        path: "/test/mui-components",
        label: "MUI Components",
        render: () => <MuiComponentsTestPage/>,
    },
    {
        path: "/test/ui-elements",
        label: "UI Elements",
        render: () => <UiElementTestPage/>,
    },
    {
        path: "/test/chip-icons",
        label: "Chip Icons",
        render: () => <ChipIconsTestPage/>,
    },
    {
        path: "/test/date-pickers",
        label: "Date Pickers",
        render: () => <NewDatePickerTestPage/>,
    },
    {
        path: "/test/new-variable-picker",
        label: "Variable Picker",
        render: () => <NewVariablePickerTestPage/>,
    },
    {
        path: "/test/rich-text",
        label: "Rich Text",
        render: () => <RichTextTestPage/>,
    },
    {
        path: "/test/emoji-picker",
        label: "Emoji Picker",
        render: () => <EmojiPickerTestPage/>,
    },
    {
        path: "/test/autocomplete",
        label: "Autocomplete",
        render: () => <AutocompleteTestPage/>,
    },
    {
        path: "/test/selects",
        label: "Selects",
        render: () => <SelectsTestPage/>,
    },
    {
        path: "/test/blackout",
        label: "Blackout",
        render: () => <BlackoutTestPage/>,
    },
];

export default function TestPage() {
    const isAuthorizedViaAdmin = useAuthorizedViaAdmin();
    const {pathname} = useLocation();

    if (!isAuthorizedViaAdmin) {
        return <Navigate to="/" replace/>;
    }

    if (pathname === "/test/settings") {
        return <Navigate to="/test/mui-components" replace/>;
    }

    return (
        <PageShell
            icon={<ScienceOutlinedIcon fontSize="inherit"/>}
            title="Test pages"
            documentTitle="Test pages"
            tabs={tabs}
        />
    );
}
